import debounce from 'lodash/debounce';
/**
 * Debounce delay before a search is actually triggered
 */
const SEARCH_DEBOUNCE_DELAY = 1000;

export default function({ customActions, makeQueryParams, serviceAPI }) {
  return {
    async initItems({ commit, getters, rootGetters }) {
      if (getters.requestItems) getters.requestItems.cancel();
      if (!makeQueryParams) return null;

      const queryParams = makeQueryParams({
        entities: rootGetters['entities/current'],
        search: getters.search,
        idx: getters.idx,
      });

      commit('SET_ITEMS_REQUEST', queryParams);
      return serviceAPI
        .getItems({
          params: queryParams,
          cancelToken: getters.requestItems.token,
        })
        .then((items) => commit('SET_ITEMS', items))
        .catch((error) => commit('SET_ITEMS_ERROR', error));
    },
    search: debounce(({ commit, dispatch }, search) => {
      commit('SET_SEARCH', search);
      dispatch('initItems');
    }, SEARCH_DEBOUNCE_DELAY),

    async searchByIdx({ dispatch, commit }, idx) {
      commit('SET_IDX', idx);
      dispatch('initItems');
    },

    setItemsPage({ dispatch }) {
      dispatch('initItems');
    },

    ...customActions,
  };
}
